import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class JobService {
  constructor(private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('jobs/search', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('jobs/list', val_params);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('jobs/all', val_params);
  }

  get(val_id: number) {
    return this.restService.get('jobs/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('jobs/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('jobs/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('jobs/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('jobs/delete', val_id);
  }
}
